(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  if (customElements.get('myc-premium-assets')) return;
  const loads = new Map();

  customElements.define('myc-premium-assets', class extends HTMLElement {
    connectedCallback() {
      if (customElements.get('myc-premium-giftbox')) return;
      const source = this.dataset.scriptUrl;
      if (!source) return;

      if (!loads.has(source)) {
        loads.set(source, new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = source;
          script.async = true;
          script.onload = resolve;
          script.onerror = () => {
            loads.delete(source);
            script.remove();
            reject(new Error('Premium giftbox script could not be loaded'));
          };
          document.head.append(script);
        }));
      }

      loads.get(source).catch(() => {
        if (!this.isConnected) return;
        const box = this.closest('myc-premium-giftbox');
        const status = box?.querySelector('[data-giftbox-status]');
        if (status) {
          status.textContent = box.dataset.error;
          status.hidden = false;
        }
      });
    }
  });
})();
// MYCLUSIV: Countdown auch für einen zunächst leeren, später per Ajax gefüllten Warenkorb bereitstellen.

(() => {
  if (customElements.get('myc-cart-countdown')) return;

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin', hourCycle: 'h23',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });

  class CartCountdown extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.render();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    render() {
      if (!this.isConnected) return;
      const now = new Date();
      const parts = formatter.formatToParts(now);
      const part = type => Number(parts.find(item => item.type === type)?.value || 0);
      const remaining = 1440 - part('hour') * 60 - part('minute');
      const hours = String(Math.floor(remaining / 60)).padStart(2, '0');
      const minutes = String(remaining % 60).padStart(2, '0');
      this.textContent = (this.dataset.timeFormat || '__H__:__M__').replace('__H__', hours).replace('__M__', minutes);
      this.timer = setTimeout(() => this.render(), (60 - part('second')) * 1000 - now.getMilliseconds() + 50);
    }
  }

  customElements.define('myc-cart-countdown', CartCountdown);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-insights"] && !Shopify.designMode) return;
  try {
    
  // MYCLUSIV: Instanzbezogene Positionierung, einschließlich Theme-Editor und Produkt-Rerender.
  if (!customElements.get('myc-review-insights')) {
    customElements.define('myc-review-insights', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;

        this._anchor = document.createComment('MYCLUSIV: Review Insights Originalposition');
        this.before(this._anchor);
        this._controller = new AbortController();
        this._media = window.matchMedia('(max-width: 999px)');
        this._onMediaChange = () => this._queuePlacement();

        if (this._media.addEventListener) {
          this._media.addEventListener('change', this._onMediaChange);
        } else {
          this._media.addListener(this._onMediaChange);
        }

        const options = { signal: this._controller.signal };
        document.addEventListener('product:rerender', (event) => {
          if (!event.target.getAttribute?.('id')?.startsWith(`product-form-main-${this.dataset.productId}-`)) return;
          // Vor dem nativen DOM-Austausch an die sichere Originalposition zurückkehren.
          this._restore();
          this._queuePlacement();
        }, { ...options, capture: true });

        document.addEventListener('shopify:section:load', () => this._queuePlacement(), options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) {
            this._destroy();
            this.remove();
          } else if (event.target.contains(this)) {
            this._restore();
            this._queuePlacement();
          }
        }, options);

        this._queuePlacement();
      }

      disconnectedCallback() {
        // Ein Positionswechsel löst ebenfalls disconnectedCallback aus.
        queueMicrotask(() => {
          if (this.isConnected || !this._controller) return;
          if (this._anchor?.isConnected) {
            this._restore();
            this._queuePlacement();
          } else {
            this._destroy();
          }
        });
      }

      _queuePlacement() {
        if (this._frame || !this._controller) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          if (!this.isConnected) return;

          const main = this._anchor?.parentElement?.closest('main');
          const productInfo = main?.querySelector(
            `.shopify-section--main-product product-rerender[observe-form^="product-form-main-${this.dataset.productId}-"]`
          );
          const description = productInfo?.querySelector(
            '.product-info__block-item[data-block-type="description"], [data-product-description], .product__description, .product-description'
          );

          if (this._media.matches && description?.parentNode) {
            if (this.nextSibling !== description) description.before(this);
          } else {
            this._restore();
          }
        });
      }

      _restore() {
        if (this._anchor?.isConnected && this._anchor.nextSibling !== this) {
          this._anchor.after(this);
        }
      }

      _destroy() {
        cancelAnimationFrame(this._frame);
        this._frame = 0;
        this._controller?.abort();
        this._controller = null;
        if (this._media?.removeEventListener) {
          this._media.removeEventListener('change', this._onMediaChange);
        } else {
          this._media?.removeListener(this._onMediaChange);
        }
        this._anchor?.remove();
        this._anchor = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
